import React, { CSSProperties, FC, ReactElement, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './index.less';

interface IProps {
  width?: string,
  height?: string,
  style?: CSSProperties,
  item?: any
}

const ActivityDynItem: FC<IProps> = (props:IProps): ReactElement => {

  const {width, height, style, item} = props
  const history = useHistory()

  const customStyle = useMemo(()=>{
    let obj:any = {}
    if(width)
      obj['width'] = width
    if(height)
      obj['height'] = height
    return {
      ...obj,
      ...style
    }
  }, [width, height, style])

  const itemClick = ()=>{
    if(item && item.infoId){
      history.push(`/activity/${item.catalogType}/detail/${item.infoId}`)
    }
  }

  return (
    <div className={styles.dynItem} style={customStyle} onClick={itemClick}>
      {
        item &&
        <>
          <div className={styles.img}>
            <img alt={item.name} src={item.coverImg}></img>
          </div>
          <div className={styles.tag}>
            <span className={styles.circle}></span>
            <span className={styles.txt}>{item.tags}</span>
          </div>
        </>
      }
    </div>
  )
}
 
export default ActivityDynItem